import axios from "axios";

export const fetchComplianceData = () => (dispatch) => {
  dispatch({ type: "COMPLIANCE_LOAD", payload: true });
  axios
    .get(`${process.env.REACT_APP_BASE_URL}/v1/public/compliance-website-data`)
    .then((response) => {
      const { data } = response;
      dispatch({ type: "COMPLIANCE_WEBSITE_DATA", payload: data });
    })
    .catch((error) => {
      const data = {
        statistics: {
          en: {
            loan_facilitated: "Failed to fetch",
            loan_facilitated_year: "Failed to fetch",
            total_outstanding: "Failed to fetch",
            total_active_borrower: "Failed to fetch",
            total_borrower: "Failed to fetch",
            total_fee: "Failed to fetch",
            total_lender: "Failed to fetch",
            total_active_lender: "Failed to fetch",
            total_lender_year: "Failed to fetch",
            total_borrower_year: "Failed to fetch",
            tkb: "-1",
          },
          id: {
            loan_facilitated: "Gagal memuat",
            loan_facilitated_year: "Gagal memuat",
            total_outstanding: "Gagal memuat",
            total_active_borrower: "Gagal memuat",
            total_borrower: "Gagal memuat",
            total_fee: "Gagal memuat",
            total_lender: "Gagal memuat",
            total_active_lender: "Gagal memuat",
            total_lender_year: "Gagal memuat",
            total_borrower_year: "Gagal memuat",
            tkb: "-1",
          },
        },
        articles: [
          {
            en: {
              header: "Failed to fetch",
              content: "Failed to fetch",
            },
            id: {
              header: "Gagal memuat",
              content: "Gagal memuat",
            },
          },
        ],
      };
      dispatch({ type: "COMPLIANCE_WEBSITE_DATA", payload: data });
    });
  dispatch({ type: "COMPLIANCE_LOAD", payload: false });
};

export const retrieveEventCompliance = (eventName, language) => (dispatch) => {
  dispatch({
    type: "SPECIFIC_EVENT",
    payload: {
      eventName,
      language,
    },
  });
};

export const resetEventCompliance = () => (dispatch) => {
  dispatch({ type: "RESET_EVENT" });
};
